import React, { useState, useEffect, useRef } from 'react';
import i18n from '../i18n';

const LANGS = [
  { code: 'ja', label: 'JA' },
  { code: 'en', label: 'EN' },
  { code: 'zh', label: 'ZH' },
  { code: 'ko', label: 'KO' },
  { code: 'de', label: 'DE' },
  { code: 'fr', label: 'FR' },
  { code: 'it', label: 'IT' },
  { code: 'tr', label: 'TR' },
  { code: 'es', label: 'ES' },
] as const;

export const LangSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState((i18n as any).language);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleChange = (code: string) => {
    (i18n as any).changeLanguage(code);
    localStorage.setItem('i18nLng', code);
    setCurrent(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="h-8 px-2.5 rounded-full text-[11px] font-bold tracking-wider text-ink-500 dark:text-ink-400 hover:bg-ink-100 dark:hover:bg-ink-800 transition flex items-center gap-1"
        title="Language"
      >
        {LANGS.find((l) => l.code === current)?.label ?? 'JA'}
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1.5 bg-white dark:bg-ink-900 border border-ink-150 dark:border-ink-800 rounded-xl shadow-pop overflow-hidden z-50 min-w-[80px]">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => handleChange(l.code)}
              className={`w-full text-left px-3 py-2 text-[12px] font-medium transition ${
                current === l.code
                  ? 'bg-brand-blue-50 text-brand-blue-700 dark:bg-brand-blue-900/40 dark:text-brand-blue-100'
                  : 'text-ink-600 dark:text-ink-300 hover:bg-ink-50 dark:hover:bg-ink-850'
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
